import React, { useEffect, useState } from "react";
import "./view.css";

export default function Add() {
  const [eduQual, setEduQual] = useState([]);
  const [count, setCount] = useState(0);
  useEffect(() => {
    setEduQual([
      {
        exam: "",
        board: "",
        year: "",
        mark: "",
        upload: "",
      },
      setCount(0),
    ]);
  }, [eduQual, count]);

  const handleAddMore = (e, i) => {
    let data = {
      exam: "",
      board: "",
      year: "",
      mark: "",
      upload: "",
    };
    let eduData = eduQual;
    eduData.push(data);
    setCount(count + 1);
  };
  return (
    <div className="add-per">
      <div className="view-container">
        <h6>
          <b>Add Intership/Training</b>
        </h6>
        <hr />

        <div className="row">
          <div className="col-8 mb-2">
            <label for="exampleInputEmail1">Full Name</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
            />
          </div>
          <div className="col-5 mb-2">
            <label for="exampleInputEmail1">Date of Birth</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
            />
          </div>
          <div className="col-3 mb-2">
            <label for="exampleInputEmail1">Gender</label>
            <div className="d-flex mt-2">
              <div className="">
                <input
                  className="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios1"
                  value="option1"
                />
                <label className="form-check-label " for="exampleRadios1">
                  &nbsp;&nbsp;Male
                </label>
              </div>

              <div className="mop">
                <input
                  className="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios2"
                  value="option2"
                />
                <label className="form-check-label" for="exampleRadios2">
                  &nbsp;&nbsp;Female
                </label>
              </div>
              <div className="mop">
                <input
                  className="form-check-input"
                  type="radio"
                  name="exampleRadios"
                  id="exampleRadios2"
                  value="option2"
                />
                <label className="form-check-label" for="exampleRadios2">
                  &nbsp;&nbsp;Other
                </label>
              </div>
            </div>
          </div>
          <div className="col-8 mb-2">
            <label for="exampleInputEmail1">Address</label>
            <textarea
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
            />
          </div>
          <div className="col-8 mb-2">
            <label for="exampleInputEmail1">Email</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
            />
          </div>
          <div className="col-8 mb-2">
            <label for="exampleInputEmail1">Phone Number</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
            />
          </div>
          {/* ---------------- */}
          <div className="col-8">
            <label for="exampleInputEmail1" className="mb-2 mt-2">
              <b>Courses Offered</b>
            </label>
            <>
              <div className="row edu mb-1">
                <div className="col-4 pb-3">
                  <label for="exampleInputEmail1">Examination passed</label>
                  <input
                    type="text"
                    className="form-control "
                    id="exampleInputEmail1"
                    name="exam"
                    aria-describedby="emailHelp"
                  />
                </div>
                <div className="col-3 pb-3">
                  <label for="exampleInputEmail1">Board/University</label>
                  <input
                    type="text"
                    className="form-control "
                    id="exampleInputEmail1"
                    name="exam"
                    aria-describedby="emailHelp"
                  />
                </div>
                <div className="col-3 pb-3">
                  <label for="exampleInputEmail1">Year of Passing</label>
                  <input
                    type="text"
                    className="form-control "
                    id="exampleInputEmail1"
                    name="exam"
                    aria-describedby="emailHelp"
                  />
                </div>
                <div className="col-2 pb-3">
                  <label for="exampleInputEmail1">Mark/grade</label>
                  <input
                    type="text"
                    className="form-control "
                    id="exampleInputEmail1"
                    name="exam"
                    aria-describedby="emailHelp"
                  />
                </div>
                <div className="col-12">
                  <label for="formFileSm" className="form-label mb-0">
                    Upload self attested photocopy of certificate
                  </label>
                  <input
                    className="form-control form-control-sm"
                    id="formFileSm"
                    name="upload"
                    type="file"
                  />
                  <small className="pers">
                    *Upload only .pdf, .doc, format and Size should be less than
                    1MB
                  </small>
                </div>
              </div>
            </>
            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-primary btn-sm d-flex justify-content-end"
              >
                Add More
              </button>
            </div>
          </div>
          {/* -------------------------- */}
          <div className="col-8 mb-2">
            <label for="exampleInputEmail1">Languages Known</label>
            <div className="row">
              <div className="col-3 mt-2">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexCheckDefault"
                    value=""
                  />
                  <label className="form-check-label" for="flexCheckDefault">
                    &nbsp;&nbsp;Malayalam
                  </label>
                </div>
              </div>
              <div className="col-3 mt-2">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexCheckDefault"
                    value=""
                  />
                  <label className="form-check-label" for="flexCheckDefault">
                    &nbsp;&nbsp; Hindi
                  </label>
                </div>
              </div>
              <div className="col-3 mt-2">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="flexCheckDefault"
                    value=""
                  />
                  <label className="form-check-label" for="flexCheckDefault">
                    &nbsp;&nbsp;English
                  </label>
                </div>
              </div>
              <div className="col-3 mt-2">
                <div className="form-check">
                  <input
                    type="checkbox"
                    name="mycheckbox"
                    className="mycheckbox1"
                    value="0"
                  />
                  <label className="form-check-label" for="flexCheckDefault">
                    &nbsp;&nbsp; Other
                  </label>
                </div>
              </div>
              <div className="col-12 mt-1">
                <input
                  type="text"
                  className="form-control "
                  id="exampleInputEmail1"
                  name="exam"
                  aria-describedby="emailHelp"
                  placeholder="Specify.."
                />
              </div>
            </div>
          </div>

          <div className="col-8">
            <label for="formFileSm" className="form-label mb-0">
              Upload photo
            </label>
            <input
              className="form-control form-control-sm"
              id="formFileSm"
              name="upload"
              type="file"
            />
            <small className="pers">
              *Upload only .jpg, .png format and Size should be less than 1MB
            </small>
          </div>
          <div className="col-8">
            <center>
              <button type="button" className="btn btn-dark mt-3">
                Submit for Acceptance
              </button>
            </center>
          </div>
          {/* ---------------- */}
        </div>
      </div>
    </div>
  );
}
